<template>
	<Space class="pd-vertical" align="center">
		<LabeledSwitch
			v-model="usePaginationValue"
			:small="true"
			:rightLabel="$t('pagination.usePagination')"
		/>
		<Pagination
			v-model:current="currentPageValue"
			v-model:pageSize="pageSizeValue"
			size="small"
			:total="itemsValue.length"
			:disabled="!usePaginationValue"
			:showSizeChanger="showSizeChanger"
			:showQuickJumper="showQuickJumper"
		/>
	</Space>
</template>

<script>
import { computed } from 'vue';
import { Space, Pagination } from 'ant-design-vue';

import { useVModel } from '@vueuse/core';
import { useOptionalVModel } from '@/components/common/useOptionalVModel';

import LabeledSwitch from '@/components/common/LabeledSwitch';

export default {
	components: {
		Space,
		Pagination,
		LabeledSwitch,
	},
	props: {
		usePagination: {
			type: Boolean,
			default: undefined,
		},
		currentPage: {
			type: Number,
			default: undefined,
		},
		defaultPageSize: {
			type: Number,
			default: 10,
		},
		pageSize: {
			type: Number,
			default: undefined,
		},
		items: {
			type: Array,
			required: true,
		},
		showQuickJumper: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:usePagination', 'update:currentPage', 'update:pageSize', 'update:items'],
	setup(props, { emit, expose }) {
		const usePaginationValue = useOptionalVModel(props, 'usePagination', emit, true);
		const currentPageValue = useOptionalVModel(props, 'currentPage', emit, 1);
		const pageSizeValue = useOptionalVModel(props, 'pageSize', emit, props.defaultPageSize);
		const itemsValue = useVModel(props, 'items', emit);
		const showSizeChanger = computed(() => props.pageSize === undefined && itemsValue.value.length > 10);
		const paginatedItems = computed(() => {
			if (usePaginationValue.value) {
				return itemsValue.value.slice((currentPageValue.value - 1) * pageSizeValue.value, currentPageValue.value * pageSizeValue.value);
			}
			return itemsValue.value;
		});
		expose({
			paginatedItems,
		})
		return {
			usePaginationValue,
			currentPageValue,
			pageSizeValue,
			showSizeChanger,
			itemsValue,
		};
	},
};
</script>
